module.exports = __webpack_public_path__ + "assets/logo.c35b8faf.svg";